import { render, staticRenderFns } from "./Warranty.vue?vue&type=template&id=09fd856c&scoped=true"
import script from "./Warranty.vue?vue&type=script&lang=js"
export * from "./Warranty.vue?vue&type=script&lang=js"
import style0 from "./Warranty.vue?vue&type=style&index=0&id=09fd856c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd856c",
  null
  
)

export default component.exports